import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { SessionActivity } from "./interface";

interface DailyPlotProps {
  interactions: SessionActivity[];
}

export const DailyPlot: React.FC<DailyPlotProps> = ({ interactions }) => {
  // Calculate daily session counts
  const dailySessionCounts = interactions.reduce((acc, sessionActivity) => {
    const date = new Date(sessionActivity.sessionStartTime).toDateString();
    if (acc[date]) {
      acc[date]++;
    } else {
      acc[date] = 1;
    }
    return acc;
  }, {} as Record<string, number>);

  // Prepare data for the chart
  const data = Object.keys(dailySessionCounts).map(date => ({
    date,
    sessions: dailySessionCounts[date],
  }));

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <span style={{ fontSize: 16, fontWeight: 'bold' }}>Daily Sessions (Session Number: {interactions.length})</span>
       </div>
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}

      >


        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="sessions" fill="#82ca22" />
      </BarChart>
    </div>
  );
};
